<div>
    <mat-accordion>   
        <mat-expansion-panel  *ngFor="let group of groups; let i=index"
        (opened)="setDefault(group)"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{group.name}}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <form action="" [formGroup]="GroupForm">
                    <mat-form-field class="full-width">
                        <mat-label>Название группы</mat-label>
                        <input formControlName="name" matInput name="name" placeholder="Группа 161-321" value="">
                    </mat-form-field>
                    
                    <button (click)="editGroup(group.id, i)" mat-raised-button>Save</button>
                    <button (click)="deleteGroup(group.id, i)" color="warn" mat-raised-button>Delete</button>
                </form>
                <div>Админы</div>
                <div *ngFor="let admin of admins; let j=index">
                    {{admin.username}} {{admin.email}}
                    <button  (click)="deleteAdmin(admin.id, j)" mat-icon-button >
                        <mat-icon >close</mat-icon>
                    </button>
                </div>
                <mat-form-field class="full-width">
                    <mat-label>Email админа</mat-label>
                    <input [formControl]="mailAdmin" matInput name="email" placeholder="Ex. admin@admin.na" value="">
                </mat-form-field>
                <button (click)="addAdmin(group.id)" mat-raised-button>Add</button>
        </mat-expansion-panel>
        <mat-expansion-panel  (opened)="GroupForm.reset()"
            >
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <button mat-mini-fab color="primary" aria-label="Example icon button with a home icon">
                            <mat-icon>add</mat-icon>
                        </button>
                    </mat-panel-title>
                    <mat-panel-description >
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <form action="" [formGroup]="GroupForm">
                    <mat-form-field class="full-width">
                        <mat-label>Название группы</mat-label>
                        <input formControlName="name" matInput name="name" placeholder="Группа 161-322" value="">
                    </mat-form-field>
                    <button (click)="addGroup()" mat-raised-button color="primary">add</button>
                </form>
        </mat-expansion-panel>
    </mat-accordion>
    </div>